import { modalsActions } from '../../modals/actions';
import MODALS from '../../modals/constants/modals';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('.do-not-formulate a').addEventListener('click', (event) => {
    event.preventDefault();
    window.store.dispatch(modalsActions.openModal(MODALS.FORBIDDEN_INGREDIENTS));
  });
});
